import React from 'react'
import { Box, Text } from '@usap/uicomponents'

export default function ReturnDetailsHeader({ orderDetails, isDesktop }) {
  const { merchantOrderId, date } = orderDetails.order
  const d = new Date(date)
  const options = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  }
  const orderDate = d.toLocaleDateString('en-US', options)
  return (
    <>
      <Box margin={{ bottom: '10px' }}>
        <Text size="xlarge" weight="bold">Return Details</Text>
      </Box>
      <Box direction={isDesktop ? 'row' : 'column'} gap="small">
        <Box direction="row">
          <Text size="small" color="dark-1">ORDER #: &nbsp;</Text>
          <Text size="small" color="dark-2" weight="bold">{ merchantOrderId }</Text>
        </Box>
        <Box direction="row">
          <Text size="small" color="dark-1">ORDER DATE: &nbsp;</Text>
          <Text size="small" color="dark-2" weight="bold">{ orderDate }</Text>
        </Box>
      </Box>
    </>
  )
}
